import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";
import { appl1ValidationSchema } from "src/applications/shared/features/commonForms/application-1/features/create/validationSchema";
import { appl110ValidationSchema } from "src/applications/application-110/features/create/validationSchema";
import { appl10049ValidationSchema } from "../../../application-10049/features/create/validationSchema";
import { appl10149ValidationSchema } from "../../../application-10149/features/create/validationSchema";
import { appl99WithAllFilesValidationSchema } from "../../features/commonForms/application99WithAllFiles/create/validationSchema";
import { appl122ValidationSchema } from "src/applications/application-122/features/create/validationSchema";
import { app12222ValidationSchema } from "src/applications/application-12222/features/create/validationSchema";
import { appl169ValidationSchema } from "src/applications/application-169/features/create/validationSchema";
import { appl171ValidationSchema } from "src/applications/application-171/features/create/validationSchema";
import { appl173ValidationSchema } from "src/applications/application-173/features/create/validationSchema";
import { app1922ValidationSchema } from "src/applications/application-1922/features/create/validationSchema";
import { appl1945ValidationSchema } from "src/applications/application-1945/features/create/validationSchema";
import { appl197ValidationSchema } from "src/applications/application-197/features/create/validationSchema";
import { appl222ValidationSchema } from "src/applications/application-222/features/create/validationSchema";
import { appl252ValidationSchema } from "src/applications/application-252/features/create/validationSchema";
import { appl4ValidationSchema } from "src/applications/application-4/features/create/validationSchema";
import { appl41ValidationSchema } from "src/applications/application-41/features/create/validationSchema";
import { app422ValidationSchema } from "src/applications/application-422/features/create/validationSchema";
import { appl45ValidationSchema } from "src/applications/application-45/features/create/validationSchema";
import { appl452ValidationSchema } from "src/applications/application-452/features/create/validationSchema";
import { appl71ValidationSchema } from "src/applications/application-71/features/create/validationSchema";
import { appl72ValidationSchema } from "src/applications/application-72/features/create/validationSchema";
import { app822ValidationSchema } from "src/applications/application-822/features/create/validationSchema";
import { appl852ValidationSchema } from "src/applications/application-852/features/create/validationSchema";
import { appl10ValidationSchema } from "../../../application-10/features/create/validationSchema";
import { appl108ValidationSchema } from "src/applications/shared/features/commonForms/application-108/features/create/validationSchema";
import { appl87ValidationSchema } from "../../../application-187New/features/create/validationSchema";
import { appl2ValidationSchema } from "../../../application-2/features/create/validationSchema";
import { appl220ValidationSchema } from "../../../application-220/features/create/validationSchema";
import { appl3ValidationSchema } from "src/applications/shared/features/commonForms/application-3/features/create/appl3ValidationSchema";
import { appl11ValidationSchema } from "../../features/commonForms/application11/features/create/validationSchema";
import { appl64ValidationSchema } from "../../features/commonForms/application64/features/create/validationSchema";
import { appl99ValidationSchema } from "../../features/commonForms/application99/features/create/validationSchema";
import { FormComponents } from "./types";
import { appl4ParentValidationSchema } from "../../features/commonForms/application-4/features/create/validationSchema";
import { appl4AutoValidationSchema } from "../../features/commonForms/application-4Auto/features/create/validationSchema";
import { appl19130ValidationSchema } from "src/applications/application-19130/features/create/validationSchema";
import { appl170ValidationSchema } from "src/applications/application-170/features/create/validationSchema";
import { appl191ValidationSchema } from "src/applications/application-191/features/create/validationSchema";
import { appl102ValidationSchema } from "../../../application-102/features/create/validationSchema";
import { appl73ValidationSchema } from "../../../application-73/features/create/validationSchema";
import { appl46ValidationSchema } from "src/applications/application-46/features/create/validationSchema";
import { appl149ValidationSchema } from "src/applications/application-149/features/create/validationSchema";
import { appl120ValidationSchema } from "../../../application-120/features/create/validationSchema";
import { appl70ValidationSchema } from "../../features/commonForms/application70/features/create/validationSchema";
import { appl1976ValidationSchema } from "../../../application-1976/features/create/validationSchema";
import { appl4000ValidationSchema } from "../../../application-4000/features/create/validationSchema";
import { appl99WithFileValidationSchema } from "../../features/commonForms/application99WithFile/features/create/validationSchema";
import { appl44ValidationSchema } from "../../features/commonForms/application44/features/create/validationSchema";
import { appl151ValidationSchema } from "../../../application-151/features/create/validationSchema";
import { appl1002ValidationSchema } from "../../../application-1002/features/create/validationSchema";
import { app1222ValidationSchema } from "src/applications/application-1222/features/create/validationSchema";
import { appl44AutoValidationSchema } from "../../features/commonForms/applicationAuto44/features/create/validationSchema";
import { appl79ValidationSchema } from "../../features/commonForms/application-79/features/create/validationSchema";
import { appl101ValidationSchema } from "src/applications/shared/features/commonForms/application-101/features/create/validationSchema";
import { appl8130ValidationSchema } from "src/applications/application-8130/features/create/validationSchema";
import { appl17ValidationSchema } from "../../features/commonForms/application-17/features/create/validationSchema";
import { appl78branchesValidationSchema } from "../../features/commonForms/application-78branches/features/create/validationSchema";
import { appl78ValidationSchema } from "../../features/commonForms/application-78/features/create/validationSchema";
import { appl830ValidationSchema } from "src/applications/application-830/features/create/validationSchema";
import { appl45AutoValidationSchema } from "../../features/commonForms/application-45Auto/features/create/validationSchema";
import { appl78AutoValidationSchema } from "../../features/commonForms/application-78Auto/features/create/validationSchema";
import { appl33ValidationSchema } from "../../features/commonForms/application-33/features/create/validationSchema";
import { appl21ValidationSchema } from "../../features/commonForms/application21/features/create/validationSchema";
import { appl1930ValidationSchema } from "src/applications/application-1930/features/create/validationSchema";
import { appl1130ValidationSchema } from "src/applications/application-1130/features/create/validationSchema";
import { appl302ValidationSchema } from "src/applications/application-302/features/create/validationSchema";
import { appl301ValidationSchema } from "src/applications/application-301/features/create/validationSchema";
import { Appl30AmendmentStatutesWithTitlesValidationSchema } from "../../features/commonForms/applicationAmendmentStatutesWithTitles30/features/create/ApplAmendmentStatutesWithTitles30ValidationSchema";
import { Appl30AmendmentStatutesValidationSchema } from "../../features/commonForms/applicationAmendmentStatutes30/features/create/ApplAmendmentStatutes30ValidationSchema";
import { appl130ValidationSchema } from "src/applications/application-130/features/create/validationSchema";
import { appl116ValidationSchema } from "src/applications/shared/features/commonForms/application116/features/create/validationSchema";
import { appl1655ValidationSchema } from "src/applications/application-1655/features/create/validationSchema";
import { appl1663ValidationSchema } from "src/applications/application-1663/features/create/validationSchema";

const App1002Details = lazyWithReload(
  () => import("../../../application-1002/features/acknowledge/App1002Details"),
);
const Appl99WithAllFilesForm = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/application99WithAllFiles/create/app99WithAllFiles-create"
    ),
);
const App99WithAllFilesDetailsProps = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/application99WithAllFiles/acknowledge/App99WithAllFilesDetails"
    ),
);

const Appl2Form = lazyWithReload(
  () => import("src/applications/application-2/features/create/appl2-create"),
);
const App2Details = lazyWithReload(
  () =>
    import("src/applications/application-2/features/acknowledge/App2Details"),
);
const Appl11Form = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application11/features/create/appl11-create"
    ),
);
const App11Details = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application11/features/acknowledge/App11Details"
    ),
);
const App70Form = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application70/features/create/app70Form"
    ),
);
const App70Details = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application70/features/acknowledge/App70Details"
    ),
);
const Appl78Form = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/application-78/features/create/appl78Form"
    ),
);
const App10Details = lazyWithReload(
  () =>
    import("src/applications/application-10/features/acknowledge/App10Details"),
);
const Appl10Form = lazyWithReload(
  () => import("src/applications/application-10/features/create/appl10Form"),
);

const App78Details = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/application-78/features/acknowledge/App78Details"
    ),
);
const App64Details = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/application64/features/acknowledge/App64Details"
    ),
);
const Appl64Form = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/application64/features/create/appl64Form"
    ),
);
const App99Details = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application99/features/acknowledge/App99Details"
    ),
);

const App110Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-110/features/acknowledge/App110Details"
    ),
);
const Appl110Form = lazyWithReload(
  () => import("src/applications/application-110/features/create/appl110Form"),
);

const App122Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-122/features/acknowledge/App122Details"
    ),
);
const Appl122Form = lazyWithReload(
  () =>
    import("src/applications/application-122/features/create/appl122-create"),
);
const App1222Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-1222/features/acknowledge/App1222Details"
    ),
);
const Appl1222Form = lazyWithReload(
  () =>
    import("src/applications/application-1222/features/create/appl1222Form"),
);
const App12222Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-12222/features/acknowledge/App12222Details"
    ),
);
const Appl12222Form = lazyWithReload(
  () =>
    import(
      "src/applications/application-12222/features/create/appl12222-create"
    ),
);
const App169Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-169/features/acknowledge/App169Details"
    ),
);
const Appl169Form = lazyWithReload(
  () =>
    import("src/applications/application-169/features/create/appl169-create"),
);
const App171Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-171/features/acknowledge/App171Details"
    ),
);
const Appl171Form = lazyWithReload(
  () => import("src/applications/application-171/features/create/appl171Form"),
);
const App173Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-173/features/acknowledge/App173Details"
    ),
);
const Appl173Form = lazyWithReload(
  () =>
    import("src/applications/application-173/features/create/appl173-create"),
);
const App45AutoDetails = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-45Auto/features/acknowledge/App45AutoDetails"
    ),
);
const Appl45AutoForm = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-45Auto/features/create/appl45AutoForm"
    ),
);
const App191Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-191/features/acknowledge/App191Details"
    ),
);
const App1922Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-1922/features/acknowledge/App1922Details"
    ),
);
const Appl1922Form = lazyWithReload(
  () =>
    import("src/applications/application-1922/features/create/appl1922-create"),
);
const App1945Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-1945/features/acknowledge/App1945Details"
    ),
);
const Appl1945Form = lazyWithReload(
  () =>
    import("src/applications/application-1945/features/create/appl1945Form"),
);
const App197Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-197/features/acknowledge/App197Details"
    ),
);
const Appl197Form = lazyWithReload(
  () =>
    import("src/applications/application-197/features/create/appl197-create"),
);
const App1976Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-1976/features/acknowledge/App1976Details"
    ),
);
const Appl1976Form = lazyWithReload(
  () =>
    import("src/applications/application-1976/features/create/appl1976Form"),
);
const App222Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-222/features/acknowledge/App222Details"
    ),
);
const Appl222Form = lazyWithReload(
  () =>
    import("src/applications/application-222/features/create/appl222-create"),
);
const App252Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-252/features/acknowledge/App252Details"
    ),
);
const Appl252Form = lazyWithReload(
  () =>
    import("src/applications/application-252/features/create/appl252-create"),
);
const App4Details = lazyWithReload(
  () =>
    import("src/applications/application-4/features/acknowledge/App4Details"),
);
const Appl4Form = lazyWithReload(
  () => import("src/applications/application-4/features/create/Appl4Form"),
);
const Appl33Form = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-33/features/create/appl33Form"
    ),
);
const App33Details = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-33/features/acknowledge/app33Details"
    ),
);
const App41Details = lazyWithReload(
  () =>
    import("src/applications/application-41/features/acknowledge/App41Details"),
);
const Appl41Form = lazyWithReload(
  () => import("src/applications/application-41/features/create/appl41Form"),
);
const App422Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-422/features/acknowledge/App422Details"
    ),
);
const Appl422Form = lazyWithReload(
  () =>
    import("src/applications/application-422/features/create/appl422-create"),
);
const App822Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-822/features/acknowledge/App822Details"
    ),
);
const App45Details = lazyWithReload(
  () =>
    import("src/applications/application-45/features/acknowledge/App45Details"),
);
const Appl45Form = lazyWithReload(
  () => import("src/applications/application-45/features/create/appl45Form"),
);
const App452Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-452/features/acknowledge/App452Details"
    ),
);
const Appl452Form = lazyWithReload(
  () =>
    import("src/applications/application-452/features/create/appl452-create"),
);
const App46Details = lazyWithReload(
  () =>
    import("src/applications/application-46/features/acknowledge/App46Details"),
);
const Appl46Form = lazyWithReload(
  () => import("src/applications/application-46/features/create/appl46Form"),
);
const App71Details = lazyWithReload(
  () =>
    import("src/applications/application-71/features/acknowledge/App71Details"),
);
const Appl71Form = lazyWithReload(
  () => import("src/applications/application-71/features/create/appl71-create"),
);
const App72Details = lazyWithReload(
  () =>
    import("src/applications/application-72/features/acknowledge/App72Details"),
);
const Appl72Form = lazyWithReload(
  () => import("src/applications/application-72/features/create/appl72-create"),
);
const Appl822Form = lazyWithReload(
  () =>
    import("src/applications/application-822/features/create/appl822-create"),
);
const App852Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-852/features/acknowledge/App852Details"
    ),
);
const Appl852Form = lazyWithReload(
  () =>
    import("src/applications/application-852/features/create/appl852-create"),
);

const App120Details = lazyWithReload(
  () => import("../../../application-120/features/acknowledge/App120Details"),
);
const Appl120Form = lazyWithReload(
  () => import("../../../application-120/features/create/appl120-create"),
);
const App220Details = lazyWithReload(
  () => import("../../../application-220/features/acknowledge/App220Details"),
);
const Appl220Form = lazyWithReload(
  () => import("../../../application-220/features/create/appl220-create"),
);
const App108Details = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-108/features/acknowledge/App108Details"
    ),
);
const Appl108Form = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-108/features/create/appl108Form"
    ),
);
const App44Details = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application44/features/acknowledge/App44Details"
    ),
);
const App44AutoDetails = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/applicationAuto44/features/acknowledge/App44AutoDetails"
    ),
);
const App44Form = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application44/features/create/App44Form"
    ),
);

const App44AutoForm = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/applicationAuto44/features/create/App44AutoForm"
    ),
);
const App21Details = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application21/features/acknowledge/App21Details"
    ),
);
const App21Form = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application21/features/create/App21Form"
    ),
);
const App151Form = lazyWithReload(
  () => import("../../../application-151/features/create/appl151-create"),
);
const App151Details = lazyWithReload(
  () => import("../../../application-151/features/acknowledge/App151Details"),
);
const Appl4000Form = lazyWithReload(
  () =>
    import("src/applications/application-4000/features/create/appl4000Form"),
);
const Appl3Form = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-3/features/create/appl3-create"
    ),
);
const App3Details = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-3/features/acknowledge/App3Details"
    ),
);
const Appl87Form = lazyWithReload(
  () => import("../../../application-187New/features/create/appl87-create"),
);
const App87Details = lazyWithReload(
  () => import("../../../application-187New/features/acknowledge/App87Details"),
);
const App4000Details = lazyWithReload(
  () => import("../../../application-4000/features/acknowledge/App4000Details"),
);

const Appl1930Form = lazyWithReload(
  () =>
    import("src/applications/application-1930/features/create/appl1930-create"),
);
const App1930Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-1930/features/acknowledge/App1930Details"
    ),
);

const Appl1130Form = lazyWithReload(
  () =>
    import("src/applications/application-1130/features/create/appl1130-create"),
);
const App1130Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-1130/features/acknowledge/App1130Details"
    ),
);

const Appl302Form = lazyWithReload(
  () =>
    import("src/applications/application-302/features/create/appl302-create"),
);
const App302Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-302/features/acknowledge/App302Details"
    ),
);

const Appl301Form = lazyWithReload(
  () =>
    import("src/applications/application-301/features/create/appl301-create"),
);
const App301Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-301/features/acknowledge/App301Details"
    ),
);

const ApplAmendmentStatutesWithTitles30Form = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/applicationAmendmentStatutesWithTitles30/features/create/ApplAmendmentStatutesWithTitles30-create"
    ),
);
const AppAmendmentStatutesWithTitles30Details = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/applicationAmendmentStatutesWithTitles30/features/acknowledge/AppAmendmentStatutesWithTitles30Details"
    ),
);

const ApplAmendmentStatutes30Form = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/applicationAmendmentStatutes30/features/create/ApplAmendmentStatutes30-create"
    ),
);
const AppAmendmentStatutes30Details = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/applicationAmendmentStatutes30/features/acknowledge/AppAmendmentStatutes30Details"
    ),
);

const Appl78AutoForm = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/application-78Auto/features/create/app78AutoForm"
    ),
);

const App78AutoDetails = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/application-78Auto/features/acknowledge/App78AutoDetails"
    ),
);
const Appl78branchesForm = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/application-78branches/features/create/appl78branchesForm"
    ),
);

const App78branchesDetails = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/application-78branches/features/acknowledge/App78branchesDetails"
    ),
);

const Appl130Form = lazyWithReload(
  () =>
    import("src/applications/application-130/features/create/appl130-create"),
);
const App130Details = lazyWithReload(
  () => import("../../../application-130/features/acknowledge/App130Details"),
);

const Appl830Form = lazyWithReload(
  () =>
    import("src/applications/application-830/features/create/appl830-create"),
);
const App830Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-830/features/acknowledge/App830Details"
    ),
);
const Appl8130Form = lazyWithReload(
  () =>
    import("src/applications/application-8130/features/create/appl8130-create"),
);
const App8130Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-8130/features/acknowledge/App8130Details"
    ),
);

const Appl73Form = lazyWithReload(
  () => import("src/applications/application-73/features/create/appl73-create"),
);
const App73Details = lazyWithReload(
  () =>
    import("src/applications/application-73/features/acknowledge/App73Details"),
);

const Appl19130Form = lazyWithReload(
  () =>
    import(
      "src/applications/application-19130/features/create/appl19130-create"
    ),
);
const App19130Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-19130/features/acknowledge/App19130Details"
    ),
);
const App149Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-149/features/acknowledge/App149Details"
    ),
);
const Appl149Form = lazyWithReload(
  () => import("src/applications/application-149/features/create/appl149Form"),
);
const Appl79FDetails = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-79/features/acknowledge/App79Details"
    ),
);
const Appl79Form = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-79/features/create/appl79-create"
    ),
);

const App101Details = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-101/features/acknowledge/App101Details"
    ),
);
const Appl101Form = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-101/features/create/appl101Form"
    ),
);
const Appl17Form = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-17/features/create/appl17Form"
    ),
);
const App17Details = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-17/features/acknowledge/App17Details"
    ),
);

const Appl102Form = lazyWithReload(
  () => import("../../../application-102/features/create/appl102-create"),
);
const App102Details = lazyWithReload(
  () => import("../../../application-102/features/acknowledge/App102Details"),
);
const Appl170Form = lazyWithReload(
  () => import("../../../application-170/features/create/appl170Form"),
);

const App170Details = lazyWithReload(
  () => import("../../../application-170/features/acknowledge/App170Details"),
);

const App1002Form = lazyWithReload(
  () => import("../../../application-1002/features/create/appl1002-create"),
);
const Appl4ParentForm = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-4/features/create/Appl4ParentForm"
    ),
);
const App4ParentDetails = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-4/features/acknowledge/App4ParentDetails"
    ),
);

const Appl4AutoForm = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-4Auto/features/create/appl4AutoForm"
    ),
);
const App4AutoDetails = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-4Auto/features/acknowledge/App4AutoDetails"
    ),
);
const Appl99Form = lazyWithReload(
  () =>
    import(
      "../../features/commonForms/application99/features/create/app99-create"
    ),
);
const App99WithFileDetails = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application99WithFile/features/aknowledge/App99WithFileDetails"
    ),
);
const Appl99WithFileForm = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application99WithFile/features/create/app99WithFile-create"
    ),
);
const App1Details = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-1/features/acknowledge/App1Details"
    ),
);
const Appl1Form = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application-1/features/create/App1Form"
    ),
);
const Appl191Form = lazyWithReload(
  () => import("src/applications/application-191/features/create/appl191Form"),
);

const App10049Form = lazyWithReload(
  () => import("../../../application-10049/features/create/appl10049-create"),
);

const App10049Details = lazyWithReload(
  () =>
    import("../../../application-10049/features/acknowledge/App10049Details"),
);
const App10149Form = lazyWithReload(
  () => import("../../../application-10149/features/create/appl10149-create"),
);

const App10149Details = lazyWithReload(
  () =>
    import("../../../application-10149/features/acknowledge/App10149Details"),
);

const Appl116Form = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application116/features/create/appl116-create"
    ),
);

const App116Details = lazyWithReload(
  () =>
    import(
      "src/applications/shared/features/commonForms/application116/features/acknowledge/App116Details"
    ),
);

const Appl1655Form = lazyWithReload(
  () => import("../../../application-1655/features/create/appl1655-create"),
);

const App1655Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-1655/features/acknowledge/app1655Details"
    ),
);

const Appl1663Form = lazyWithReload(
  () => import("../../../application-1663/features/create/appl1663-create"),
);

const App1663Details = lazyWithReload(
  () =>
    import(
      "src/applications/application-1663/features/acknowledge/appl1663Details"
    ),
);
/**
 * This is the mapping of formId to the components that will be rendered
 * for each page of the form.
 *
 */
const app44AutoConfig = {
  form: <App44AutoForm />,
  acknowledge: <App44AutoDetails model={{}} />,
  validator: appl44AutoValidationSchema,
};
export const formComponents: FormComponents = {
  "1": {
    form: <Appl1Form />,
    acknowledge: <App1Details model={{}} />,
    validator: appl1ValidationSchema,
  },
  "4": {
    form: <Appl4Form />,
    acknowledge: <App4Details model={{}} />,
    validator: appl4ValidationSchema,
  },
  "2": {
    form: <Appl2Form />,
    acknowledge: <App2Details model={{}} />,
    validator: appl2ValidationSchema,
  },
  "41": {
    form: <Appl41Form />,
    acknowledge: <App41Details model={{}} />,
    validator: appl41ValidationSchema,
  },
  "45": {
    form: <Appl45Form />,
    acknowledge: <App45Details model={{}} />,
    validator: appl45ValidationSchema,
  },
  "46": {
    form: <Appl46Form />,
    acknowledge: <App46Details model={{}} />,
    validator: appl46ValidationSchema,
  },
  "71": {
    form: <Appl71Form />,
    acknowledge: <App71Details model={{}} />,
    validator: appl71ValidationSchema,
  },
  "72": {
    form: <Appl72Form />,
    acknowledge: <App72Details model={{}} />,
    validator: appl72ValidationSchema,
  },
  "104": {
    form: <Appl4ParentForm />,
    acknowledge: <App4ParentDetails model={{}} />,
    validator: appl4ParentValidationSchema,
  },
  "110": {
    form: <Appl110Form />,
    acknowledge: <App110Details model={{}} />,
    validator: appl110ValidationSchema,
  },
  "111": {
    form: <Appl11Form />,
    acknowledge: <App11Details model={{}} />,
    validator: appl11ValidationSchema,
  },
  "117": {
    form: <Appl4AutoForm />,
    acknowledge: <App4AutoDetails model={{}} />,
    validator: appl4AutoValidationSchema,
  },
  "120": {
    validator: appl120ValidationSchema,
    form: <Appl120Form />,
    acknowledge: <App120Details model={{}} />,
  },
  "130": {
    form: <Appl130Form />,
    acknowledge: <App130Details model={{}} />,
    validator: appl130ValidationSchema,
  },
  "220": {
    validator: appl220ValidationSchema,
    form: <Appl220Form />,
    acknowledge: <App220Details model={{}} />,
  },
  "230": {
    form: <ApplAmendmentStatutes30Form />,
    acknowledge: <AppAmendmentStatutes30Details model={{}} />,
    validator: Appl30AmendmentStatutesValidationSchema,
  },
  "270": {
    form: <App70Form />,
    validator: appl70ValidationSchema,
    acknowledge: <App70Details model={{}} />,
  },
  "301": {
    form: <Appl301Form />,
    acknowledge: <App301Details model={{}} />,
    validator: appl301ValidationSchema,
  },
  "302": {
    form: <Appl302Form />,
    acknowledge: <App302Details model={{}} />,
    validator: appl302ValidationSchema,
  },
  "420": {
    validator: appl220ValidationSchema,
    form: <Appl220Form />,
    acknowledge: <App220Details model={{}} />,
  },
  "430": {
    form: <ApplAmendmentStatutes30Form />,
    acknowledge: <AppAmendmentStatutes30Details model={{}} />,
    validator: Appl30AmendmentStatutesValidationSchema,
  },
  "1070": {
    form: <App70Form />,
    validator: appl70ValidationSchema,
    acknowledge: <App70Details model={{}} />,
  },
  "820": {
    validator: appl120ValidationSchema,
    form: <Appl120Form />,
    acknowledge: <App120Details model={{}} />,
  },
  "830": {
    form: <Appl830Form />,
    acknowledge: <App830Details model={{}} />,
    validator: appl830ValidationSchema,
  },
  "1920": {
    validator: appl120ValidationSchema,
    form: <Appl120Form />,
    acknowledge: <App120Details model={{}} />,
  },
  "6820": {
    validator: appl220ValidationSchema,
    form: <Appl220Form />,
    acknowledge: <App220Details model={{}} />,
  },
  "122": {
    form: <Appl122Form />,
    acknowledge: <App122Details model={{}} />,
    validator: appl122ValidationSchema,
  },
  "145": {
    form: <Appl45AutoForm />,
    acknowledge: <App45AutoDetails model={{}} />,
    validator: appl45AutoValidationSchema,
  },
  "169": {
    form: <Appl169Form />,
    acknowledge: <App169Details model={{}} />,
    validator: appl169ValidationSchema,
  },

  "191": {
    form: <Appl191Form />,
    acknowledge: <App191Details model={{}} />,
    validator: appl191ValidationSchema,
  },
  "204": {
    form: <Appl4ParentForm />,
    acknowledge: <App4ParentDetails model={{}} />,
    validator: appl4ParentValidationSchema,
  },
  "171": {
    form: <Appl171Form />,
    acknowledge: <App171Details model={{}} />,
    validator: appl171ValidationSchema,
  },
  "172": {
    form: <Appl17Form />,
    acknowledge: <App17Details model={{}} />,
    validator: appl17ValidationSchema,
  },
  "173": {
    form: <Appl173Form />,
    acknowledge: <App173Details model={{}} />,
    validator: appl173ValidationSchema,
  },
  "178": {
    form: <Appl78Form />,
    acknowledge: <App78Details model={{}} />,
    validator: appl78ValidationSchema,
  },

  "20178": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "6578": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "6978": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "7078": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "378": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "878": {
    form: <Appl78Form />,
    acknowledge: <App78Details model={{}} />,
    validator: appl78ValidationSchema,
  },
  "1078": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "1978": {
    form: <Appl78Form />,
    acknowledge: <App78Details model={{}} />,
    validator: appl78ValidationSchema,
  },
  "2078": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "4078": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "8078": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "11178": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "12078": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "13078": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "19078": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "187": {
    validator: appl87ValidationSchema,
    form: <Appl87Form />,
    acknowledge: <App87Details model={{}} />,
  },
  "197": {
    form: <Appl197Form />,
    acknowledge: <App197Details model={{}} />,
    validator: appl197ValidationSchema,
  },
  "211": {
    form: <Appl11Form />,
    acknowledge: <App11Details model={{}} />,
    validator: appl11ValidationSchema,
  },
  "222": {
    form: <Appl222Form />,
    acknowledge: <App222Details model={{}} />,
    validator: appl222ValidationSchema,
  },
  "252": {
    form: <Appl252Form />,
    acknowledge: <App252Details model={{}} />,
    validator: appl252ValidationSchema,
  },
  "264": {
    form: <Appl64Form />,
    acknowledge: <App64Details model={{}} />,
    validator: appl64ValidationSchema,
  },
  "287": {
    validator: appl87ValidationSchema,
    form: <Appl87Form />,
    acknowledge: <App87Details model={{}} />,
  },
  "364": {
    form: <Appl64Form />,
    acknowledge: <App64Details model={{}} />,
    validator: appl64ValidationSchema,
  },
  "400": {
    form: <Appl33Form />,
    acknowledge: <App33Details model={{}} />,
    validator: appl33ValidationSchema,
  },
  "401": {
    form: <Appl33Form />,
    acknowledge: <App33Details model={{}} />,
    validator: appl33ValidationSchema,
  },
  "404": {
    form: <Appl4ParentForm />,
    acknowledge: <App4ParentDetails model={{}} />,
    validator: appl4ParentValidationSchema,
  },
  "411": {
    form: <Appl11Form />,
    acknowledge: <App11Details model={{}} />,
    validator: appl11ValidationSchema,
  },
  "422": {
    form: <Appl422Form />,
    acknowledge: <App422Details model={{}} />,
    validator: app422ValidationSchema,
  },
  "452": {
    form: <Appl452Form />,
    acknowledge: <App452Details model={{}} />,
    validator: appl452ValidationSchema,
  },
  "464": {
    form: <Appl64Form />,
    acknowledge: <App64Details model={{}} />,
    validator: appl64ValidationSchema,
  },
  "487": {
    validator: appl87ValidationSchema,
    form: <Appl87Form />,
    acknowledge: <App87Details model={{}} />,
  },
  "804": {
    form: <Appl4ParentForm />,
    acknowledge: <App4ParentDetails model={{}} />,
    validator: appl4ParentValidationSchema,
  },
  "811": {
    form: <Appl11Form />,
    acknowledge: <App11Details model={{}} />,
    validator: appl11ValidationSchema,
  },
  "817": {
    form: <Appl4AutoForm />,
    acknowledge: <App4AutoDetails model={{}} />,
    validator: appl4AutoValidationSchema,
  },
  "822": {
    form: <Appl822Form />,
    acknowledge: <App822Details model={{}} />,
    validator: app822ValidationSchema,
  },
  "852": {
    form: <Appl852Form />,
    acknowledge: <App852Details model={{}} />,
    validator: appl852ValidationSchema,
  },
  "887": {
    validator: appl87ValidationSchema,
    form: <Appl87Form />,
    acknowledge: <App87Details model={{}} />,
  },
  "121": {
    form: <App21Form />,
    acknowledge: <App21Details model={{}} />,
    validator: appl21ValidationSchema,
  },
  "821": {
    form: <App21Form />,
    acknowledge: <App21Details model={{}} />,
    validator: appl21ValidationSchema,
  },
  "1921": {
    form: <App21Form />,
    acknowledge: <App21Details model={{}} />,
    validator: appl21ValidationSchema,
  },
  "964": {
    form: <Appl64Form />,
    acknowledge: <App64Details model={{}} />,
    validator: appl64ValidationSchema,
  },
  "1002": {
    form: <App1002Form />,
    acknowledge: <App1002Details />,
    validator: appl1002ValidationSchema,
  },
  "1101": {
    form: <Appl101Form />,
    acknowledge: <App101Details model={{}} />,
    validator: appl101ValidationSchema,
  },
  "2101": {
    form: <Appl101Form />,
    acknowledge: <App101Details model={{}} />,
    validator: appl101ValidationSchema,
  },
  "4101": {
    form: <Appl101Form />,
    acknowledge: <App101Details model={{}} />,
    validator: appl101ValidationSchema,
  },
  "8101": {
    form: <Appl101Form />,
    acknowledge: <App101Details model={{}} />,
    validator: appl101ValidationSchema,
  },
  "11101": {
    form: <Appl101Form />,
    acknowledge: <App101Details model={{}} />,
    validator: appl101ValidationSchema,
  },
  "14101": {
    form: <Appl101Form />,
    acknowledge: <App101Details model={{}} />,
    validator: appl101ValidationSchema,
  },
  "16101": {
    form: <Appl101Form />,
    acknowledge: <App101Details model={{}} />,
    validator: appl101ValidationSchema,
  },
  "18101": {
    form: <Appl101Form />,
    acknowledge: <App101Details model={{}} />,
    validator: appl101ValidationSchema,
  },
  "19101": {
    form: <Appl101Form />,
    acknowledge: <App101Details model={{}} />,
    validator: appl101ValidationSchema,
  },
  "65101": {
    form: <Appl101Form />,
    acknowledge: <App101Details model={{}} />,
    validator: appl101ValidationSchema,
  },
  "1130": {
    form: <Appl1130Form />,
    acknowledge: <App1130Details model={{}} />,
    validator: appl1130ValidationSchema,
  },
  "1222": {
    form: <Appl1222Form />,
    acknowledge: <App1222Details model={{}} />,
    validator: app1222ValidationSchema,
  },
  "1464": {
    form: <Appl64Form />,
    acknowledge: <App64Details model={{}} />,
    validator: appl64ValidationSchema,
  },
  "1664": {
    form: <Appl64Form />,
    acknowledge: <App64Details model={{}} />,
    validator: appl64ValidationSchema,
  },
  // Add more formId mappings here
  "1770": {
    form: <App70Form />,
    validator: appl70ValidationSchema,
    acknowledge: <App70Details model={{}} />,
  },
  "1864": {
    form: <Appl64Form />,
    acknowledge: <App64Details model={{}} />,
    validator: appl64ValidationSchema,
  },
  "1987": {
    validator: appl87ValidationSchema,
    form: <Appl87Form />,
    acknowledge: <App87Details model={{}} />,
  },
  "1870": {
    form: <App70Form />,
    validator: appl70ValidationSchema,
    acknowledge: <App70Details model={{}} />,
  },
  "1901": {
    form: <Appl1Form />,
    acknowledge: <App1Details model={{}} />,
    validator: appl1ValidationSchema,
  },
  "1904": {
    form: <Appl4ParentForm />,
    acknowledge: <App4ParentDetails model={{}} />,
    validator: appl4ParentValidationSchema,
  },
  "1911": {
    form: <Appl11Form />,
    acknowledge: <App11Details model={{}} />,
    validator: appl11ValidationSchema,
  },
  "1917": {
    form: <Appl17Form />,
    acknowledge: <App17Details model={{}} />,
    validator: appl17ValidationSchema,
  },
  "1922": {
    form: <Appl1922Form />,
    acknowledge: <App1922Details model={{}} />,
    validator: app1922ValidationSchema,
  },
  "1930": {
    form: <Appl1930Form />,
    acknowledge: <App1930Details model={{}} />,
    validator: appl1930ValidationSchema,
  },
  "1945": {
    form: <Appl1945Form />,
    acknowledge: <App1945Details model={{}} />,
    validator: appl1945ValidationSchema,
  },
  "1976": {
    form: <Appl1976Form />,
    acknowledge: <App1976Details model={{}} />,
    validator: appl1976ValidationSchema,
  },
  "4000": {
    form: <Appl4000Form />,
    acknowledge: <App4000Details model={{}} />,
    validator: appl4000ValidationSchema,
  },
  "4130": {
    form: <ApplAmendmentStatutesWithTitles30Form />,
    acknowledge: <AppAmendmentStatutesWithTitles30Details model={{}} />,
    validator: Appl30AmendmentStatutesWithTitlesValidationSchema,
  },
  "6464": {
    form: <Appl64Form />,
    acknowledge: <App64Details model={{}} />,
    validator: appl64ValidationSchema,
  },
  "6864": {
    form: <Appl64Form />,
    acknowledge: <App64Details model={{}} />,
    validator: appl64ValidationSchema,
  },
  "6887": {
    validator: appl87ValidationSchema,
    form: <Appl87Form />,
    acknowledge: <App87Details model={{}} />,
  },
  "8130": {
    form: <Appl8130Form />,
    acknowledge: <App8130Details model={{}} />,
    validator: appl8130ValidationSchema,
  },
  "9901": {
    form: <Appl99WithAllFilesForm />,
    validator: appl99WithAllFilesValidationSchema,
    acknowledge: <App99WithAllFilesDetailsProps model={{}} />,
  },
  "9902": {
    form: <Appl99Form />,
    validator: appl99ValidationSchema,
    acknowledge: <App99Details model={{}} />,
  },
  "9903": {
    form: <Appl99WithFileForm />,
    validator: appl99WithFileValidationSchema,
    acknowledge: <App99WithFileDetails model={{}} />,
  },
  "9904": {
    form: <Appl99Form />,
    validator: appl99ValidationSchema,
    acknowledge: <App99Details model={{}} />,
  },
  "9908": {
    form: <Appl99WithAllFilesForm />,
    validator: appl99WithAllFilesValidationSchema,
    acknowledge: <App99WithAllFilesDetailsProps model={{}} />,
  },
  "9909": {
    form: <Appl99Form />,
    validator: appl99ValidationSchema,
    acknowledge: <App99Details model={{}} />,
  },
  "9910": {
    form: <Appl99Form />,
    validator: appl99ValidationSchema,
    acknowledge: <App99Details model={{}} />,
  },
  "9912": {
    form: <Appl99Form />,
    validator: appl99ValidationSchema,
    acknowledge: <App99Details model={{}} />,
  },
  "9911": {
    form: <Appl99WithFileForm />,
    validator: appl99WithFileValidationSchema,
    acknowledge: <App99WithFileDetails model={{}} />,
  },
  "9913": {
    form: <Appl99Form />,
    validator: appl99ValidationSchema,
    acknowledge: <App99Details model={{}} />,
  },
  "9919": {
    form: <Appl99Form />,
    validator: appl99ValidationSchema,
    acknowledge: <App99Details model={{}} />,
  },
  "9920": {
    form: <Appl99Form />,
    validator: appl99ValidationSchema,
    acknowledge: <App99Details model={{}} />,
  },
  "9964": {
    form: <Appl99Form />,
    validator: appl99ValidationSchema,
    acknowledge: <App99Details model={{}} />,
  },
  "9965": {
    form: <Appl99WithAllFilesForm />,
    validator: appl99WithAllFilesValidationSchema,
    acknowledge: <App99WithAllFilesDetailsProps model={{}} />,
  },
  "9968": {
    form: <Appl99Form />,
    validator: appl99ValidationSchema,
    acknowledge: <App99Details model={{}} />,
  },
  "9969": {
    form: <Appl99WithAllFilesForm />,
    validator: appl99WithAllFilesValidationSchema,
    acknowledge: <App99WithAllFilesDetailsProps model={{}} />,
  },
  "9970": {
    form: <Appl99WithAllFilesForm />,
    validator: appl99WithAllFilesValidationSchema,
    acknowledge: <App99WithAllFilesDetailsProps model={{}} />,
  },
  "19017": {
    form: <Appl4AutoForm />,
    acknowledge: <App4AutoDetails model={{}} />,
    validator: appl4AutoValidationSchema,
  },
  "9905": {
    form: <Appl99Form />,
    validator: appl99ValidationSchema,
    acknowledge: <App99Details model={{}} />,
  },
  "12222": {
    form: <Appl12222Form />,
    acknowledge: <App12222Details model={{}} />,
    validator: app12222ValidationSchema,
  },
  "1370": {
    validator: appl70ValidationSchema,
    form: <App70Form />,
    acknowledge: <App70Details model={{}} />,
  },
  "9914": {
    form: <Appl99WithFileForm />,
    validator: appl99WithFileValidationSchema,
    acknowledge: <App99WithFileDetails model={{}} />,
  },
  "9915": {
    form: <Appl99WithFileForm />,
    validator: appl99WithFileValidationSchema,
    acknowledge: <App99WithFileDetails model={{}} />,
  },
  "9916": {
    form: <Appl99WithFileForm />,
    validator: appl99WithFileValidationSchema,
    acknowledge: <App99WithFileDetails model={{}} />,
  },
  "9918": {
    form: <Appl99WithFileForm />,
    validator: appl99WithFileValidationSchema,
    acknowledge: <App99WithFileDetails model={{}} />,
  },
  "1470": {
    validator: appl70ValidationSchema,
    form: <App70Form />,
    acknowledge: <App70Details model={{}} />,
  },
  "1970": {
    validator: appl70ValidationSchema,
    form: <App70Form />,
    acknowledge: <App70Details model={{}} />,
  },
  "2070": {
    validator: appl70ValidationSchema,
    form: <App70Form />,
    acknowledge: <App70Details model={{}} />,
  },
  "6470": {
    validator: appl70ValidationSchema,
    form: <App70Form />,
    acknowledge: <App70Details model={{}} />,
  },
  "6970": {
    validator: appl70ValidationSchema,
    form: <App70Form />,
    acknowledge: <App70Details model={{}} />,
  },
  "7070": {
    validator: appl70ValidationSchema,
    form: <App70Form />,
    acknowledge: <App70Details model={{}} />,
  },
  "10070": {
    validator: appl70ValidationSchema,
    form: <App70Form />,
    acknowledge: <App70Details model={{}} />,
  },
  "6570": {
    validator: appl70ValidationSchema,
    form: <App70Form />,
    acknowledge: <App70Details model={{}} />,
  },
  "1170": {
    validator: appl70ValidationSchema,
    form: <App70Form />,
    acknowledge: <App70Details model={{}} />,
  },
  "1270": {
    validator: appl70ValidationSchema,
    form: <App70Form />,
    acknowledge: <App70Details model={{}} />,
  },
  "6870": {
    validator: appl70ValidationSchema,
    form: <App70Form />,
    acknowledge: <App70Details model={{}} />,
  },
  "19045": {
    form: <Appl45AutoForm />,
    acknowledge: <App45AutoDetails model={{}} />,
    validator: appl45AutoValidationSchema,
  },
  "1108": {
    form: <Appl108Form />,
    acknowledge: <App108Details model={{}} />,
    validator: appl108ValidationSchema,
  },
  "2108": {
    form: <Appl108Form />,
    acknowledge: <App108Details model={{}} />,
    validator: appl108ValidationSchema,
  },
  "2130": {
    form: <ApplAmendmentStatutesWithTitles30Form />,
    acknowledge: <AppAmendmentStatutesWithTitles30Details model={{}} />,
    validator: Appl30AmendmentStatutesWithTitlesValidationSchema,
  },
  "18130": {
    form: <ApplAmendmentStatutesWithTitles30Form />,
    acknowledge: <AppAmendmentStatutesWithTitles30Details model={{}} />,
    validator: Appl30AmendmentStatutesWithTitlesValidationSchema,
  },
  "4108": {
    form: <Appl108Form />,
    acknowledge: <App108Details model={{}} />,
    validator: appl108ValidationSchema,
  },
  "8108": {
    form: <Appl108Form />,
    acknowledge: <App108Details model={{}} />,
    validator: appl108ValidationSchema,
  },
  "11108": {
    form: <Appl108Form />,
    acknowledge: <App108Details model={{}} />,
    validator: appl108ValidationSchema,
  },
  "14108": {
    form: <Appl108Form />,
    acknowledge: <App108Details model={{}} />,
    validator: appl108ValidationSchema,
  },
  "16108": {
    form: <Appl108Form />,
    acknowledge: <App108Details model={{}} />,
    validator: appl108ValidationSchema,
  },
  "18108": {
    form: <Appl108Form />,
    acknowledge: <App108Details model={{}} />,
    validator: appl108ValidationSchema,
  },
  "19108": {
    form: <Appl108Form />,
    acknowledge: <App108Details model={{}} />,
    validator: appl108ValidationSchema,
  },
  "65108": {
    form: <Appl108Form />,
    acknowledge: <App108Details model={{}} />,
    validator: appl108ValidationSchema,
  },
  "10": {
    form: <Appl10Form />,
    acknowledge: <App10Details model={{}} />,
    validator: appl10ValidationSchema,
  },
  "144": {
    form: <App44Form />,
    acknowledge: <App44Details model={{}} />,
    validator: appl44ValidationSchema,
  },
  "844": {
    form: <App44Form />,
    acknowledge: <App44Details model={{}} />,
    validator: appl44ValidationSchema,
  },
  "1044": {
    form: <App44AutoForm />,
    acknowledge: <App44AutoDetails model={{}} />,
    validator: appl44AutoValidationSchema,
  },
  "1944": {
    form: <App44Form />,
    acknowledge: <App44Details model={{}} />,
    validator: appl44ValidationSchema,
  },
  "2044": {
    form: <App44AutoForm />,
    acknowledge: <App44AutoDetails model={{}} />,
    validator: appl44AutoValidationSchema,
  },
  "3044": {
    form: <App44AutoForm />,
    acknowledge: <App44AutoDetails model={{}} />,
    validator: appl44AutoValidationSchema,
  },
  "4044": {
    form: <App44AutoForm />,
    acknowledge: <App44AutoDetails model={{}} />,
    validator: appl44AutoValidationSchema,
  },
  "8044": {
    form: <App44AutoForm />,
    acknowledge: <App44AutoDetails model={{}} />,
    validator: appl44AutoValidationSchema,
  },
  "16044": {
    form: <App44AutoForm />,
    acknowledge: <App44AutoDetails model={{}} />,
    validator: appl44AutoValidationSchema,
  },
  "18044": {
    form: <App44AutoForm />,
    acknowledge: <App44AutoDetails model={{}} />,
    validator: appl44AutoValidationSchema,
  },
  "19044": {
    form: <App44AutoForm />,
    acknowledge: <App44AutoDetails model={{}} />,
    validator: appl44AutoValidationSchema,
  },
  "64044": {
    form: <App44AutoForm />,
    acknowledge: <App44AutoDetails model={{}} />,
    validator: appl44AutoValidationSchema,
  },
  "1544": app44AutoConfig,
  "2144": app44AutoConfig,
  "7044": app44AutoConfig,
  "6944": app44AutoConfig,
  "6844": app44AutoConfig,
  "6744": app44AutoConfig,
  "6544": app44AutoConfig,
  "6444": app44AutoConfig,
  "20044": app44AutoConfig,
  "1844": app44AutoConfig,
  "1744": app44AutoConfig,
  "1444": app44AutoConfig,
  "1344": app44AutoConfig,
  "1244": app44AutoConfig,
  "1144": app44AutoConfig,
  "10044": app44AutoConfig,
  "9044": app44AutoConfig,
  "6644": app44AutoConfig,
  "151": {
    validator: appl151ValidationSchema,
    form: <App151Form />,
    acknowledge: <App151Details model={{}} />,
  },
  "801": {
    form: <Appl1Form />,
    acknowledge: <App1Details model={{}} />,
    validator: appl1ValidationSchema,
  },
  "303": {
    acknowledge: <App3Details model={{}} />,
    form: <Appl3Form />,
    validator: appl3ValidationSchema,
  },
  "304": {
    acknowledge: <App3Details model={{}} />,
    form: <Appl3Form />,
    validator: appl3ValidationSchema,
  },
  "1178": {
    acknowledge: <App78branchesDetails model={{}} />,
    form: <Appl78branchesForm />,
    validator: appl78branchesValidationSchema,
  },
  "1578": {
    acknowledge: <App78branchesDetails model={{}} />,
    form: <Appl78branchesForm />,
    validator: appl78branchesValidationSchema,
  },
  "8178": {
    acknowledge: <App78branchesDetails model={{}} />,
    form: <Appl78branchesForm />,
    validator: appl78branchesValidationSchema,
  },
  "19130": {
    acknowledge: <App19130Details model={{}} />,
    form: <Appl19130Form />,
    validator: appl19130ValidationSchema,
  },
  "19178": {
    acknowledge: <App78branchesDetails model={{}} />,
    form: <Appl78branchesForm />,
    validator: appl78branchesValidationSchema,
  },
  "102": {
    acknowledge: <App102Details model={{}} />,
    form: <Appl102Form />,
    validator: appl102ValidationSchema,
  },

  "73": {
    acknowledge: <App73Details model={{}} />,
    form: <Appl73Form />,
    validator: appl73ValidationSchema,
  },
  "149": {
    acknowledge: <App149Details model={{}} />,
    form: <Appl149Form />,
    validator: appl149ValidationSchema,
  },

  "170": {
    acknowledge: <App170Details model={{}} />,
    form: <Appl170Form />,
    validator: appl170ValidationSchema,
  },
  "370": {
    form: <App70Form />,
    validator: appl70ValidationSchema,
    acknowledge: <App70Details model={{}} />,
  },
  "870": {
    form: <App70Form />,
    validator: appl70ValidationSchema,
    acknowledge: <App70Details model={{}} />,
  },
  "970": {
    form: <App70Form />,
    validator: appl70ValidationSchema,
    acknowledge: <App70Details model={{}} />,
  },

  "6579": {
    form: <Appl79Form />,
    acknowledge: <Appl79FDetails model={{}} />,
    validator: appl79ValidationSchema,
  },
  "6979": {
    form: <Appl79Form />,
    acknowledge: <Appl79FDetails model={{}} />,
    validator: appl79ValidationSchema,
  },
  "7079": {
    form: <Appl79Form />,
    acknowledge: <Appl79FDetails model={{}} />,
    validator: appl79ValidationSchema,
  },
  "20179": {
    form: <Appl79Form />,
    acknowledge: <Appl79FDetails model={{}} />,
    validator: appl79ValidationSchema,
  },
  "470": {
    form: <App70Form />,
    validator: appl70ValidationSchema,
    acknowledge: <App70Details model={{}} />,
  },
  "349": {
    acknowledge: <Appl79FDetails model={{}} />,
    form: <Appl79Form />,
    validator: appl79ValidationSchema,
  },
  "849": {
    acknowledge: <App149Details model={{}} />,
    form: <Appl149Form />,
    validator: appl149ValidationSchema,
  },
  "1049": {
    acknowledge: <Appl79FDetails model={{}} />,
    form: <Appl79Form />,
    validator: appl79ValidationSchema,
  },
  "1149": {
    acknowledge: <Appl79FDetails model={{}} />,
    form: <Appl79Form />,
    validator: appl79ValidationSchema,
  },
  "1949": {
    acknowledge: <App149Details model={{}} />,
    form: <Appl149Form />,
    validator: appl149ValidationSchema,
  },
  "2049": {
    acknowledge: <Appl79FDetails model={{}} />,
    form: <Appl79Form />,
    validator: appl79ValidationSchema,
  },
  "4049": {
    acknowledge: <Appl79FDetails model={{}} />,
    form: <Appl79Form />,
    validator: appl79ValidationSchema,
  },
  "68078": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "8049": {
    acknowledge: <Appl79FDetails model={{}} />,
    form: <Appl79Form />,
    validator: appl79ValidationSchema,
  },
  "12049": {
    acknowledge: <Appl79FDetails model={{}} />,
    form: <Appl79Form />,
    validator: appl79ValidationSchema,
  },
  "13049": {
    acknowledge: <Appl79FDetails model={{}} />,
    form: <Appl79Form />,
    validator: appl79ValidationSchema,
  },
  "19049": {
    acknowledge: <Appl79FDetails model={{}} />,
    form: <Appl79Form />,
    validator: appl79ValidationSchema,
  },
  "10049": {
    acknowledge: <App10049Details model={{}} />,
    form: <App10049Form />,
    validator: appl10049ValidationSchema,
  },
  "10149": {
    acknowledge: <App10149Details model={{}} />,
    form: <App10149Form />,
    validator: appl10149ValidationSchema,
  },
  "68049": {
    acknowledge: <Appl79FDetails model={{}} />,
    form: <Appl79Form />,
    validator: appl79ValidationSchema,
  },
  "6811": {
    form: <Appl11Form />,
    acknowledge: <App11Details model={{}} />,
    validator: appl11ValidationSchema,
  },
  "2116": {
    form: <Appl116Form />,
    acknowledge: <App116Details model={{}} />,
    validator: appl116ValidationSchema,
  },
  "4116": {
    form: <Appl116Form />,
    acknowledge: <App116Details model={{}} />,
    validator: appl116ValidationSchema,
  },
  "8116": {
    form: <Appl116Form />,
    acknowledge: <App116Details model={{}} />,
    validator: appl116ValidationSchema,
  },
  "10116": {
    form: <Appl116Form />,
    acknowledge: <App116Details model={{}} />,
    validator: appl116ValidationSchema,
  },
  "11116": {
    form: <Appl116Form />,
    acknowledge: <App116Details model={{}} />,
    validator: appl116ValidationSchema,
  },
  "14078": {
    form: <Appl78AutoForm />,
    acknowledge: <App78AutoDetails model={{}} />,
    validator: appl78AutoValidationSchema,
  },
  "14079": {
    form: <Appl79Form />,
    acknowledge: <Appl79FDetails model={{}} />,
    validator: appl79ValidationSchema,
  },
  "14116": {
    form: <Appl116Form />,
    acknowledge: <App116Details model={{}} />,
    validator: appl116ValidationSchema,
  },
  "16116": {
    form: <Appl116Form />,
    acknowledge: <App116Details model={{}} />,
    validator: appl116ValidationSchema,
  },
  "18116": {
    form: <Appl116Form />,
    acknowledge: <App116Details model={{}} />,
    validator: appl116ValidationSchema,
  },
  "19116": {
    form: <Appl116Form />,
    acknowledge: <App116Details model={{}} />,
    validator: appl116ValidationSchema,
  },
  "65116": {
    form: <Appl116Form />,
    acknowledge: <App116Details model={{}} />,
    validator: appl116ValidationSchema,
  },
  "14130": {
    form: <ApplAmendmentStatutesWithTitles30Form />,
    acknowledge: <AppAmendmentStatutesWithTitles30Details model={{}} />,
    validator: Appl30AmendmentStatutesWithTitlesValidationSchema,
  },
  "1655": {
    form: <Appl1655Form />,
    acknowledge: <App1655Details model={{}} />,
    validator: appl1655ValidationSchema,
  },
  "1663": {
    form: <Appl1663Form />,
    acknowledge: <App1663Details model={{}} />,
    validator: appl1663ValidationSchema,
  },
  // Add more formId mappings here
};
